import React, { useEffect, useState } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    ListGroup,
    Button,
    Form,
    Badge,
    Modal,
    Dropdown,
    ButtonGroup,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import "./home.css";
import { Carousel } from "react-bootstrap";
import { getNewsShareUrl } from "../utils/share";

// ✅ BASE URL — clean karo
const BASE = (() => {
    let url = process.env.REACT_APP_API_URL || "https://news-portal-l6pf.onrender.com";
    url = url.replace(/\/$/, "");                    // trailing slash kaadho
    if (url.endsWith("/api")) url = url.slice(0, -4); // /api kaadho
    return url;
})();

const API_URL = `${BASE}/api/news`;
const CATEGORY_API = `${BASE}/api/news/categories`;
const SUBSCRIBE_URL = `${BASE}/api/subscribe`;

// ⬆️ IMAGE_URL hataavi didhu — niche getImage ma handle thay che

const SectionHeader = ({ title, right }) => (
    <div className="d-flex align-items-center justify-content-between mb-3 mt-4">
        <h3 className="m-0 section-title">{title}</h3>
        {right}
    </div>
);

const incrementView = async (post) => {
    const id = post?._id || post?.id;
    if (!id) return;
    try {
        await fetch(`${API_URL}/views/${id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
        });
    } catch (err) {
        console.error("View update failed:", err);
    }
};

const Home = () => {
    const [news, setNews] = useState([]);
    const [categories, setCategories] = useState([]);
    const [newsCategories, setNewsCategories] = useState([]);
    const [show, setShow] = useState(false);
    const [selectedPost, setSelectedPost] = useState(null);
    const [videoLimit, setVideoLimit] = useState(4);
    const [adsLimit, setAdsLimit] = useState(3);
    const [subEmail, setSubEmail] = useState("");
    const [subLoading, setSubLoading] = useState(false);
    const [subMsg, setSubMsg] = useState({ type: "", text: "" });

    useEffect(() => {
        fetchNews();
        fetchCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchNews = async () => {
        try {
            const res = await fetch(`${API_URL}?limit=100`);
            const result = await res.json();
            const data = result?.data || [];
            setNews(data);
            setNewsCategories([...new Set(data.map((i) => i.category).filter(Boolean))]);
        } catch (err) {
            console.error("Fetch news error:", err);
        }
    };

    const fetchCategories = async () => {
        try {
            const res = await fetch(CATEGORY_API);
            const result = await res.json();
            const categoriesData = result?.categories || result?.data || [];
            setCategories(Array.isArray(categoriesData) ? categoriesData : []);
        } catch (err) {
            console.error("Fetch categories error:", err);
        }
    };

    const handleSubscribe = async (e) => {
        e.preventDefault();
        const email = subEmail.trim();
        if (!email) {
            setSubMsg({ type: "error", text: "Please enter your email." });
            return;
        }
        try {
            setSubLoading(true);
            setSubMsg({ type: "", text: "" });
            const res = await fetch(SUBSCRIBE_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) {
                setSubMsg({ type: "error", text: json?.message || "Subscribe failed. Please try again." });
                return;
            }
            setSubMsg({ type: "success", text: json?.message || "Subscribed successfully!" });
            setSubEmail("");
        } catch {
            setSubMsg({ type: "error", text: "Network error. Please try again." });
        } finally {
            setSubLoading(false);
        }
    };

    // ✅ FIXED getImage — Cloudinary + Local + Fallback trano handle kare che
    const getImage = (item, kind = "news") => {
        const newsPlaceholder = "https://placehold.co/1200x650?text=No+Image";
        const adPlaceholder = "https://placehold.co/900x500?text=Sponsored+Ad";

        if (!item) return kind === "ad" ? adPlaceholder : newsPlaceholder;

        // ✅ resolveUrl — 3 cases:
        // 1. Full URL (http/https) — Cloudinary → direct return
        // 2. Partial path (/uploads/file.jpg) — juna local news → BASE + path
        // 3. Empty/null → null return karo, placeholder use thase
        const resolveUrl = (path) => {
            if (!path || path.trim() === "") return null;
            if (path.startsWith("http://") || path.startsWith("https://")) return path; // ✅ Cloudinary
            const clean = path.startsWith("/") ? path : `/${path}`;
            return `${BASE}${clean}`; // ✅ Local fallback
        };

        if (kind === "ad") {
            return (
                resolveUrl(item.adImage) ||
                resolveUrl(item.image) ||
                adPlaceholder
            );
        }

        return (
            resolveUrl(item.image) ||
            resolveUrl(item.imagePath) ||
            newsPlaceholder
        );
    };

    const getWriterName = (item) =>
        item?.writerName || item?.writer || item?.author ||
        item?.createdBy || item?.postedBy || item?.reporter || "";

    const getCategoryName = (cat) => {
        if (!cat) return "";
        return typeof cat === "string" ? cat : cat.name || "";
    };

    const getPostDateValue = (item) =>
        item?.publishedAt || item?.createdAt || item?.updatedAt || item?.date || "";

    const formatNewsDate = (value) => {
        if (!value) return "";
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return "";
        return d.toLocaleDateString("en-US", {
            weekday: "short", month: "short", day: "2-digit", year: "numeric",
        });
    };

    const getViews = (item) => {
        const v = item?.views ?? item?.viewCount ?? item?.totalViews ?? item?.impressions ?? 0;
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    };

    const formatViews = (n) => {
        const num = Number(n) || 0;
        if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(1)}M`;
        if (num >= 1_000) return `${(num / 1_000).toFixed(1)}K`;
        return `${num}`;
    };

    const getVideoUrl = (item) =>
        (item?.videoUrl || item?.videoURL || item?.youtubeUrl || item?.youtubeURL ||
            item?.ytUrl || item?.ytURL || item?.video || "").toString().trim();

    const extractYouTubeId = (input) => {
        if (!input) return null;
        const str = String(input).trim();
        if (!str) return null;
        const iframeSrcMatch = str.match(/src=["']([^"']+)["']/i);
        const value = iframeSrcMatch ? iframeSrcMatch[1] : str;
        if (/^[a-zA-Z0-9_-]{11}$/.test(value)) return value;
        const fixed = /^https?:\/\//i.test(value) ? value : `https://${value}`;
        const patterns = [
            /youtu\.be\/([a-zA-Z0-9_-]{11})/,
            /[?&]v=([a-zA-Z0-9_-]{11})/,
            /youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/,
            /youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/,
            /youtube\.com\/live\/([a-zA-Z0-9_-]{11})/,
            /youtube\.com\/v\/([a-zA-Z0-9_-]{11})/,
        ];
        for (const p of patterns) {
            const m = fixed.match(p);
            if (m?.[1]) return m[1];
        }
        try {
            const u = new URL(fixed);
            const v = u.searchParams.get("v");
            if (v && /^[a-zA-Z0-9_-]{11}$/.test(v)) return v;
            const parts = u.pathname.split("/").filter(Boolean);
            const last = parts[parts.length - 1];
            if (last && /^[a-zA-Z0-9_-]{11}$/.test(last)) return last;
        } catch { return null; }
        return null;
    };

    const getYouTubeEmbed = (input, { autoplay = false } = {}) => {
        const id = extractYouTubeId(input);
        if (!id) return null;
        const params = new URLSearchParams({
            rel: "0", modestbranding: "1", playsinline: "1", controls: "1",
        });
        if (autoplay) { params.set("autoplay", "1"); params.set("mute", "1"); }
        return `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`;
    };

    const openNewTab = (url) => window.open(url, "_blank", "noopener,noreferrer");

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            alert("Link copied!");
        } catch { window.prompt("Copy this link:", text); }
    };

    const shareTo = (platform, post) => {
        if (!post) return;
        const url = getNewsShareUrl(post);
        const title = (post.title || "News").trim();
        const text = `${title}\n${url}`;
        switch (platform) {
            case "whatsapp": openNewTab(`https://wa.me/?text=${encodeURIComponent(text)}`); break;
            case "facebook": openNewTab(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`); break;
            case "x": openNewTab(`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`); break;
            case "telegram": openNewTab(`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`); break;
            case "linkedin": openNewTab(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`); break;
            case "instagram": openNewTab("https://www.instagram.com/proud_tapi_news"); break;
            case "email": openNewTab(`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text)}`); break;
            case "copy": copyToClipboard(url); break;
            default: break;
        }
    };

    const ShareMenu = ({ post, size = "sm" }) => (
        <Dropdown as={ButtonGroup} className="share-group">
            <Button size={size} variant="success" className="share-btn" onClick={() => shareTo("whatsapp", post)}>
                <i className="bi bi-share-fill" /> Share
            </Button>
            <Dropdown.Toggle split size={size} variant="success" />
            <Dropdown.Menu align="end" className="share-dropdown">
                <Dropdown.Item className="share-item whatsapp" onClick={() => shareTo("whatsapp", post)}><i className="bi bi-whatsapp" /> WhatsApp</Dropdown.Item>
                <Dropdown.Item className="share-item facebook" onClick={() => shareTo("facebook", post)}><i className="bi bi-facebook" /> Facebook</Dropdown.Item>
                <Dropdown.Item className="share-item x" onClick={() => shareTo("x", post)}><i className="bi bi-twitter-x" /> X (Twitter)</Dropdown.Item>
                <Dropdown.Item className="share-item telegram" onClick={() => shareTo("telegram", post)}><i className="bi bi-telegram" /> Telegram</Dropdown.Item>
                <Dropdown.Item className="share-item linkedin" onClick={() => shareTo("linkedin", post)}><i className="bi bi-linkedin" /> LinkedIn</Dropdown.Item>
                <Dropdown.Item className="share-item instagram" onClick={() => shareTo("instagram", post)}><i className="bi bi-instagram" /> Instagram</Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item className="share-item email" onClick={() => shareTo("email", post)}><i className="bi bi-envelope-fill" /> Email</Dropdown.Item>
                <Dropdown.Item className="share-item copy" onClick={() => shareTo("copy", post)}><i className="bi bi-link-45deg" /> Copy Link</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );

    const handleShow = async (post) => {
        if (!post) return;
        const id = post?._id || post?.id;
        incrementView(post);
        const nextViews = getViews(post) + 1;
        if (id) {
            setNews((prev) => prev.map((n) => {
                const nid = n?._id || n?.id;
                return nid === id ? { ...n, views: getViews(n) + 1 } : n;
            }));
        }
        setSelectedPost({ ...post, views: nextViews });
        setShow(true);
    };

    const handleClose = () => { setShow(false); setSelectedPost(null); };

    const breaking = news?.[0];
    const trending = [...news].slice(0, 5);
    const videoNews = news.filter((n) => getYouTubeEmbed(getVideoUrl(n)));
    const adsNews = news.filter((n) => n.adTitle || n.adImage);

    // ✅ onError fallback — image load na thay to placeholder show karo
    const handleImgError = (e, kind = "news") => {
        e.target.onerror = null;
        e.target.src = kind === "ad"
            ? "https://placehold.co/900x500?text=Ad"
            : "https://placehold.co/400x250?text=No+Image";
    };

    return (
        <>
            {/* ✅ HERO — image Cloudinary URL direct background ma */}
            {breaking && (
                <div
                    className="hero"
                    style={{ backgroundImage: `url(${getImage(breaking, "news")})` }}
                >
                    <div className="hero-overlay">
                        <Container>
                            <Badge bg="danger" className="mb-2">Breaking</Badge>
                            <h1 className="hero-title">{breaking.title}</h1>
                            {(getWriterName(breaking) || formatNewsDate(getPostDateValue(breaking))) && (
                                <div className="news-meta news-meta-hero">
                                    {getWriterName(breaking) && (
                                        <span className="news-writer">By {getWriterName(breaking)}</span>
                                    )}
                                    {formatNewsDate(getPostDateValue(breaking)) && (
                                        <span className="news-date">{formatNewsDate(getPostDateValue(breaking))}</span>
                                    )}
                                    <span className="news-views">
                                        <i className="bi bi-eye" /> {formatViews(getViews(breaking))} views
                                    </span>
                                </div>
                            )}
                            <p className="hero-desc">{breaking.shortDesc}</p>
                            <div className="d-flex gap-2 flex-wrap">
                                <Button className="hero-read-btn" variant="light" onClick={() => handleShow(breaking)}>
                                    Read Full Story
                                </Button>
                                <ShareMenu post={breaking} />
                            </div>
                        </Container>
                    </div>
                </div>
            )}

            <Container className="mt-4">
                {/* VIDEO NEWS */}
                <SectionHeader title="Video News" />
                <Row className="g-3">
                    {videoNews.slice(0, videoLimit).map((item, i) => {
                        const embed = getYouTubeEmbed(getVideoUrl(item));
                        if (!embed) return null;
                        return (
                            <Col md={3} sm={6} key={i}>
                                <Card className="shadow-sm h-100 card-hover">
                                    <div className="video-embed">
                                        <iframe
                                            src={embed}
                                            title={item.title}
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            loading="lazy"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                        />
                                    </div>
                                    <Card.Body>
                                        <Card.Title className="title-sm">{item.title}</Card.Title>
                                        <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                            <Button size="sm" onClick={() => handleShow(item)}>Open</Button>
                                            <span className="news-views">
                                                <i className="bi bi-eye" /> {formatViews(getViews(item))} views
                                            </span>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>

                {videoNews.length > videoLimit && (
                    <div className="text-center mt-3">
                        <Button variant="outline-secondary" onClick={() => setVideoLimit((v) => v + 4)}>
                            View More Videos
                        </Button>
                    </div>
                )}

                {/* CATEGORIES SECTION */}
                {categories.length > 0 && (
                    <>
                        <SectionHeader title="Categories" />
                        <Row className="g-3 mb-4">
                            {categories.slice(0, 8).map((cat, i) => (
                                <Col md={3} sm={6} key={i}>
                                    <Card className="shadow-sm h-100 card-hover text-center">
                                        <Card.Body className="d-flex align-items-center justify-content-center">
                                            <Link to={`/category/${encodeURIComponent(cat.name)}`} className="text-decoration-none">
                                                <div>
                                                    <h6 className="mb-1">{cat.name}</h6>
                                                    <small className="text-muted">{cat.group}</small>
                                                </div>
                                            </Link>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                        {categories.length > 8 && (
                            <div className="text-center mb-4">
                                <Link to="/categories" className="btn btn-outline-primary">View All Categories</Link>
                            </div>
                        )}
                    </>
                )}

                <Row className="mt-4">
                    {/* LEFT — Top Stories */}
                    <Col md={8}>
                        <SectionHeader title="Top Stories" />
                        {news.slice(0, 5).map((item, i) => (
                            <Card className="mb-3 shadow-sm card-hover" key={i}>
                                <Row className="g-0">
                                    <Col md={4}>
                                        <div className="thumb-wrap thumb-wrap-md">
                                            <Card.Img
                                                className="thumb thumb-md"
                                                src={getImage(item, "news")}
                                                alt={item.title}
                                                onError={(e) => handleImgError(e, "news")}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={8}>
                                        <Card.Body>
                                            <div className="d-flex align-items-center justify-content-between gap-2 mb-2 flex-wrap">
                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                    {item.category && <Badge bg="secondary">{item.category}</Badge>}
                                                    <span className="news-views">
                                                        <i className="bi bi-eye" /> {formatViews(getViews(item))} views
                                                    </span>
                                                </div>
                                            </div>
                                            <Card.Title className="title-md">{item.title}</Card.Title>
                                            {(getWriterName(item) || formatNewsDate(getPostDateValue(item))) && (
                                                <div className="news-meta">
                                                    {getWriterName(item) && <span className="news-writer">By {getWriterName(item)}</span>}
                                                    {formatNewsDate(getPostDateValue(item)) && <span className="news-date">{formatNewsDate(getPostDateValue(item))}</span>}
                                                </div>
                                            )}
                                            <Card.Text className="text-muted news-description">{item.shortDesc}</Card.Text>
                                            <div className="d-flex gap-2 flex-wrap">
                                                <Button size="sm" onClick={() => handleShow(item)}>Read</Button>
                                                <ShareMenu post={item} size="sm" />
                                            </div>
                                        </Card.Body>
                                    </Col>
                                </Row>
                            </Card>
                        ))}
                    </Col>

                    {/* RIGHT */}
                    <Col md={4}>
                        {/* Trending */}
                        <Card className="mb-3 shadow-sm">
                            <Card.Body>
                                <h5 className="mb-3">Trending</h5>
                                <ListGroup variant="flush">
                                    {trending.map((item, i) => (
                                        <ListGroup.Item key={i} className="px-0 d-flex justify-content-between align-items-start gap-2">
                                            <div className="d-flex flex-column">
                                                <span className="small">{item.title}</span>
                                                <span className="news-views mt-1">
                                                    <i className="bi bi-eye" /> {formatViews(getViews(item))} views
                                                </span>
                                            </div>
                                            <Button size="sm" variant="outline-primary" onClick={() => handleShow(item)}>Read</Button>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </Card.Body>
                        </Card>

                        {/* Sponsored Ads */}
                        <Card className="shadow-sm">
                            <Card.Body>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="m-0">Sponsored</h5>
                                    {adsNews.length > adsLimit && (
                                        <Button size="sm" variant="outline-secondary" onClick={() => setAdsLimit((v) => v + 3)}>
                                            View More Ads
                                        </Button>
                                    )}
                                </div>
                                {adsNews.length > 0 ? (
                                    <Carousel
                                        indicators={adsNews.slice(0, adsLimit).length > 1}
                                        controls={adsNews.slice(0, adsLimit).length > 1}
                                        interval={4000}
                                        pause="hover"
                                        fade
                                    >
                                        {adsNews.slice(0, adsLimit).map((ad, i) => (
                                            <Carousel.Item key={i}>
                                                <div className="position-relative text-center">
                                                    <div className="ad-tag">Sponsored</div>
                                                    <img
                                                        className="d-block w-100 ad-slider-img"
                                                        src={getImage(ad, "ad")}
                                                        alt={ad.adTitle || "Advertisement"}
                                                        onError={(e) => handleImgError(e, "ad")}
                                                    />
                                                    <div className="mt-3 px-2">
                                                        <div className="fw-semibold">{ad.adTitle || "Advertisement"}</div>
                                                        {ad.adDesc && <div className="text-muted small mt-1">{ad.adDesc}</div>}
                                                        {ad.adLink && (
                                                            <Button className="mt-2" size="sm" variant="primary" as="a" href={ad.adLink} target="_blank" rel="noreferrer">
                                                                Learn More
                                                            </Button>
                                                        )}
                                                    </div>
                                                </div>
                                            </Carousel.Item>
                                        ))}
                                    </Carousel>
                                ) : (
                                    <div className="text-muted small">No sponsored ads yet.</div>
                                )}
                            </Card.Body>
                        </Card>

                        {/* More Stories */}
                        <Card className="mt-3 shadow-sm">
                            <Card.Body>
                                <h5 className="mb-3">📰 More Stories</h5>
                                <ListGroup variant="flush">
                                    {news.slice(5, 10).map((item, i) => (
                                        <ListGroup.Item key={i} className="px-0 d-flex justify-content-between align-items-start gap-2">
                                            <div className="d-flex flex-column">
                                                <span className="small">{item.title}</span>
                                                <span className="news-views mt-1">
                                                    <i className="bi bi-eye" /> {formatViews(getViews(item))} views
                                                </span>
                                            </div>
                                            <Button size="sm" variant="outline-primary" onClick={() => handleShow(item)}>Read</Button>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Category Sections */}
                {categories.map((cat, i) => {
                    const name = getCategoryName(cat);
                    if (!name) return null;
                    const filtered = news.filter((n) => n.category === name);
                    return (
                        <div key={i} className="mt-4">
                            <SectionHeader
                                title={name}
                                right={<Link className="btn btn-outline-primary btn-sm" to={`/category/${encodeURIComponent(name)}`}>View all</Link>}
                            />
                            <Row className="g-3">
                                {filtered.length === 0 ? (
                                    <Col xs={12}>
                                        <div className="alert alert-info mb-0">
                                            No published news available yet for this category.
                                        </div>
                                    </Col>
                                ) : (
                                    filtered.slice(0, 3).map((item, index) => (
                                        <Col md={4} sm={6} key={index}>
                                            <Card className="shadow-sm h-100 card-hover">
                                                <div className="thumb-wrap">
                                                    <Card.Img
                                                        className="thumb"
                                                        src={getImage(item, "news")}
                                                        alt={item.title}
                                                        onError={(e) => handleImgError(e, "news")}
                                                    />
                                                </div>
                                                <Card.Body>
                                                    <Card.Title className="title-sm">{item.title}</Card.Title>
                                                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                                        <Button size="sm" onClick={() => handleShow(item)}>Read</Button>
                                                        <span className="news-views">
                                                            <i className="bi bi-eye" /> {formatViews(getViews(item))} views
                                                        </span>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))
                                )}
                            </Row>
                        </div>
                    );
                })}

                {/* Subscribe */}
               {/* <div className="text-center my-5 subscribe-box">
                    <h4 className="mb-3">Subscribe to our Newsletter</h4>
                    <Form className="d-flex justify-content-center gap-2 flex-wrap" onSubmit={handleSubscribe}>
                        <Form.Control
                            placeholder="Email"
                            className="subscribe-input"
                            value={subEmail}
                            onChange={(e) => setSubEmail(e.target.value)}
                        />
                        <Button variant="primary" type="submit" disabled={subLoading}>
                            {subLoading ? "Subscribing..." : "Subscribe"}
                        </Button>
                    </Form>
                    {subMsg.text && (
                        <div className={`small mt-2 ${subMsg.type === "success" ? "text-success" : "text-danger"}`}>
                            {subMsg.text}
                        </div>
                    )}
                    <div className="text-muted small mt-2">Get top stories daily in your inbox.</div>
                </div> */}
            </Container>

            {/* MODAL */}
            <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{selectedPost?.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedPost && (
                        <>
                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                                {(getWriterName(selectedPost) || formatNewsDate(getPostDateValue(selectedPost))) && (
                                    <div className="news-meta">
                                        {getWriterName(selectedPost) && <span className="news-writer">By {getWriterName(selectedPost)}</span>}
                                        {formatNewsDate(getPostDateValue(selectedPost)) && <span className="news-date">{formatNewsDate(getPostDateValue(selectedPost))}</span>}
                                    </div>
                                )}
                                <span className="news-views">
                                    <i className="bi bi-eye" /> {formatViews(getViews(selectedPost))} views
                                </span>
                            </div>

                            {/* ✅ Image with Cloudinary URL + onError fallback */}
                            <img
                                className="w-100 rounded mb-3"
                                src={getImage(selectedPost, "news")}
                                alt={selectedPost.title}
                                onError={(e) => handleImgError(e, "news")}
                            />

                            {/* Video */}
                            {(() => {
                                const vUrl = getVideoUrl(selectedPost);
                                const embed = getYouTubeEmbed(vUrl, { autoplay: false });
                                if (!embed) return null;
                                return (
                                    <div className="video-embed mb-3">
                                        <iframe
                                            src={embed}
                                            title={selectedPost.title}
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            loading="lazy"
                                        />
                                    </div>
                                );
                            })()}

                            <p className="mt-3 news-article-text news-content">{selectedPost.content}</p>

                            <div className="d-flex gap-2 flex-wrap">
                                <ShareMenu post={selectedPost} size="sm" />
                                <Button variant="outline-secondary" size="sm" onClick={() => shareTo("copy", selectedPost)}>
                                    <i className="bi bi-link-45deg" /> Copy Link
                                </Button>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>

            {/* Back to top */}
            <Button className="back-to-top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                <i className="bi bi-arrow-up" />
            </Button>
        </>
    );
};

export default Home;